import React from 'react';

import { Stack } from '@mui/material';

import type { LuxPlusPromoBannerCarouselState } from '~/utils/luxPlusPayloadBuilder/promoBannerCarousel/types';

import { PAYLOAD_BUILDER_REQUIRED_FIELDS_SX } from '../../FieldLabels';
import LoadPayloadSection from '../../LoadPayloadSection';

import PromoBannerCarouselBannersSection from './PromoBannerCarouselBannersSection';

interface PromoBannerCarouselPayloadBuilderFormProps {
  collapseResetKey: number;
  state: LuxPlusPromoBannerCarouselState;
  onChange: (next: LuxPlusPromoBannerCarouselState) => void;
  loadJson: string;
  onLoadJsonChange: (value: string) => void;
  loadError: string | null;
  loadCollapseKey?: number;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function PromoBannerCarouselPayloadBuilderForm({
  collapseResetKey,
  state,
  onChange,
  loadJson,
  onLoadJsonChange,
  loadError,
  loadCollapseKey,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: PromoBannerCarouselPayloadBuilderFormProps) {
  return (
    <Stack spacing={2}>
      <LoadPayloadSection
        loadJson={loadJson}
        loadError={loadError}
        collapseKey={loadCollapseKey}
        onLoadJsonChange={onLoadJsonChange}
        onLoadPayload={onLoadPayload}
        onClearLoad={onClearLoad}
        onUploadFile={onUploadFile}
      />

      <Stack key={collapseResetKey} sx={PAYLOAD_BUILDER_REQUIRED_FIELDS_SX}>
        <PromoBannerCarouselBannersSection
          promos={state.promos}
          onChange={(promos) => onChange({ ...state, promos })}
        />
      </Stack>
    </Stack>
  );
}
